import { BUILD_DATE, BUILD_NUMBER } from 'settings';
import { hjTagging } from 'utils';

import logoImage from './assets/img/logo.png';

console.log(
  ' %c      ',
  `
  display: block;
  font-size: 60px;
  line-height: 60px;
  text-align: center;
  background: url(${logoImage}) no-repeat;
  background-size: 170px 50px;
`
);
console.log(`v3.${BUILD_NUMBER}  ${BUILD_DATE}`);
hjTagging(`v3.${BUILD_NUMBER}-${BUILD_DATE}`);
